module.exports = __webpack_public_path__ + "static/forecast/weather/nightclear-00cb571dabeac8744d451ab5c0c7d624.svg";